const copyTextToClipboard = (text: any): Promise<void> => {
  if ('clipboard' in navigator) {
    return Promise.resolve(navigator.clipboard.writeText(text))
  } else {
    return Promise.reject(new Error('Clipboard API not supported'))
  }
}

export default copyTextToClipboard
